import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import { Waypoint } from 'react-waypoint';
import { Paper, Table, TableContainer, TableBody, TableHead, TableCell, TableRow, TableFooter, TablePagination, Link, Menu as MuiMenu, MenuItem, ListItemIcon, ListItemText, Typography, withStyles, IconButton } from '@material-ui/core';
import { MoreHoriz } from '@material-ui/icons';
import { Loader } from '@kailona/ui';
var HeadCell = withStyles(function (theme) {
  return {
    root: {
      fontWeight: 'bold',
      fontSize: '14px'
    }
  };
})(TableCell);
var Menu = withStyles({
  paper: {
    marginTop: '45px'
  }
})(MuiMenu);

var KailonaTable = /*#__PURE__*/function (_Component) {
  _inherits(KailonaTable, _Component);

  var _super = _createSuper(KailonaTable);

  function KailonaTable(props) {
    var _this;

    _classCallCheck(this, KailonaTable);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleContextMenu", function (e, rowData) {
      _this.setState({
        anchorEl: e.currentTarget,
        rowData: rowData
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleContextMenuClose", function () {
      _this.setState({
        anchorEl: null,
        rowData: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMenuItemClick", function (menuItemClickEvent) {
      _this.handleContextMenuClose();

      if (menuItemClickEvent && typeof menuItemClickEvent === 'function') {
        menuItemClickEvent(_this.state.rowData);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleScroll", function () {
      if (_this.props.loading) {
        return;
      }

      var fetchNewData = _this.props.fetchNewData;

      if (fetchNewData && typeof fetchNewData === 'function') {
        var previousDataLength = _this.props.data.length;

        _this.setState({
          previousDataLength: previousDataLength
        });

        fetchNewData();
      }
    });

    _this.state = {
      anchorEl: null,
      rowData: null,
      previousDataLength: 0
    };
    return _this;
  }

  _createClass(KailonaTable, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var columnsLength = this.props.columns.length;
      var noDataColSpan = this.props.contextMenu ? columnsLength + 1 : columnsLength;
      var rowHeight = 50;
      var isWayPointAvailable = !this.state.loading && this.state.previousDataLength !== this.props.data.length;
      var tableHeight = (this.props.rowsPerPage + 1) * rowHeight;
      return /*#__PURE__*/React.createElement(Paper, {
        style: {
          height: "".concat(tableHeight, "px"),
          width: '100%',
          position: 'relative',
          overflowY: 'auto'
        }
      }, /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, this.props.columns.map(function (col) {
        return /*#__PURE__*/React.createElement(HeadCell, null, col.label);
      }), this.props.contextMenu && /*#__PURE__*/React.createElement(HeadCell, null))), /*#__PURE__*/React.createElement(TableBody, null, this.props.data.map(function (record) {
        return /*#__PURE__*/React.createElement(TableRow, null, _this2.props.columns.map(function (col, index) {
          var displayText = record[col.key];

          if (col.display && typeof col.display === 'function') {
            displayText = col.display(record, record[col.key]);
          }

          return /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("div", null, displayText), index === 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Link, {
            color: "primary"
          }, record.source)));
        }), _this2.props.contextMenu && /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(IconButton, {
          onClick: function onClick(e) {
            return _this2.toggleContextMenu(e, record);
          }
        }, /*#__PURE__*/React.createElement(MoreHoriz, null))));
      })), /*#__PURE__*/React.createElement(TableFooter, null, this.props.loading && /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
        colSpan: this.props.columns.length,
        align: "center"
      }, /*#__PURE__*/React.createElement(Loader, null))), !this.props.loading && (!this.props.data || !this.props.data.length) && /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
        colSpan: noDataColSpan,
        align: "center"
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h5"
      }, t('ehr', 'No data available'))))))), isWayPointAvailable && /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "10px",
          height: '20px'
        }
      }, /*#__PURE__*/React.createElement(Waypoint, {
        onEnter: this.handleScroll
      })), this.props.pagination && /*#__PURE__*/React.createElement(TablePagination, {
        rowsPerPageOptions: [1, 5, 10, 25],
        component: "div",
        count: this.props.data.length,
        rowsPerPage: this.props.rowsPerPage,
        page: this.state.page,
        onChangePage: function onChangePage(e, page) {
          return _this2.props.onChangePage(e, page);
        },
        onChangeRowsPerPage: function onChangeRowsPerPage(e) {
          return _this2.props.onChangeRowsPerPage(e);
        }
      }), /*#__PURE__*/React.createElement(Menu, {
        id: "table-context-menu",
        anchorEl: this.state.anchorEl,
        keepMounted: true,
        open: Boolean(this.state.anchorEl),
        onClose: this.handleContextMenuClose
      }, this.props.contextMenu && this.props.contextMenu.map(function (menuItem) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          onClick: function onClick() {
            return _this2.handleMenuItemClick(menuItem.onClick);
          }
        }, /*#__PURE__*/React.createElement(ListItemIcon, {
          size: "small",
          style: {
            minWidth: '32px'
          }
        }, menuItem.icon), /*#__PURE__*/React.createElement(ListItemText, {
          primary: menuItem.label
        }));
      })));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return KailonaTable;
}(Component);

export { KailonaTable as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(HeadCell, "HeadCell", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/Table/KailonaTable.js");
  reactHotLoader.register(Menu, "Menu", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/Table/KailonaTable.js");
  reactHotLoader.register(KailonaTable, "KailonaTable", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/Table/KailonaTable.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();